export default "__VITE_ASSET__CzsBcBGl__"